import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import Header from './Header';
import { menuConfig } from './MenuConfig';
import LoadingDots from './LoadingDots';

export default function DashboardLayout({ user, handleLogout }) {
  const [darkMode, setDarkMode] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [activePage, setActivePage] = useState('dashboard');
  const [pageProps, setPageProps] = useState({});

  if (!user || !user.role) {
    return <div className="p-4"><LoadingDots height={10} width={30} color="#38AD3E" />
</div>;
  }
  const { role } = user;
  const menuItems = menuConfig[role] || [];
  const activeItem = menuItems.find((item) => item.key === activePage);

    const navigateTo = (page, props = {}) => {
    setActivePage(page);
    setPageProps(props);
  };
  // console.log("🔍 Dashboard passing props to active component:", { user, activePage, pageProps });

  const RenderComponent = activeItem?.component || (() => <p>Page Not Found</p>);

  return (
    <div className={`dashboard-layout ${darkMode ? 'dark' : 'light'}`}>
      <div className="min-h-screen flex justify-between">
        <Sidebar
          user={user}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          setActivePage={setActivePage}
        />

        <div className={`main-content ${collapsed ? 'collapsed' : ''}`}>
          <div className="flex justify-end mr-[4rem] mt-[1.3rem]">
            <Header
              user={user}
              darkMode={darkMode}
              setDarkMode={setDarkMode}
              handleLogout={handleLogout}
            />
          </div>

          <main className="dashboard-main">
            <RenderComponent user={user} navigateTo={navigateTo} 
              {...pageProps}  />
          
          </main>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  handleLogout: PropTypes.func.isRequired,
};
